import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DiaDeAtendimentoDTO, HoraDeAtendimentoDTO, HoraDeAtendimentoResponseDTO } from '../../models/hora-de-atendimento.models';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root',
})
export class DiaDeAtendimentoService {
  private baseUrl = '/diaDeAtendimento';

  constructor(private apiService: ApiService) { }

  get(url: string, data?: any): Observable<any> {
    const queryParams = this.apiService.buildQueryParams(data);
    const path = queryParams ? `${url}?${queryParams}` : url;

    return this.apiService.read<any>(path);
  }

  getById<T>(url: string): Observable<any> {
    return this.apiService.read<any>(url);
  }

  post<T>(
    url: string,
    data: DiaDeAtendimentoDTO | undefined
  ): Observable<DiaDeAtendimentoDTO> {
    return this.apiService.create<DiaDeAtendimentoDTO>(url, data);
  }

  criar(diaDaSemana: string) {
    return this.apiService.create<any>(this.baseUrl, { diaDaSemana });
  }

  put<T>(
    url: string,
    data: DiaDeAtendimentoDTO
  ): Observable<DiaDeAtendimentoDTO> {
    return this.apiService.update<DiaDeAtendimentoDTO>(url, data);
  }

  delete<T>(url: string): Observable<any> {
    return this.apiService.delete(url);
  }

}
